import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductListProductGridInformation from "@tCooneyBrothers/Widgets/ProductListProductGridInformation";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-top: 0;
            padding-bottom: 10px;
        `,
    },
    imageWrapper: {
        css: css`
            padding: 10px 50px;
        `,
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    showTextBadges,
    // maximumNumberOfImageBadges,
    // maximumNumberOfTextBadges,
}) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            {/* <StyledWrapper {...styles.imageWrapper}>
                <ProductListProductImage
                    showImage={showImage}
                    showCompare={showCompare}
                    showImageBadge={showImageBadges}
                    showTextBadge={showTextBadges}
                />
            </StyledWrapper> */}
            <ProductListProductGridInformation
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showPrice={showPrice}
                showAddToList={showAddToList}
                showImage={showImage}
                showImageBadges={showImageBadges}
                showTextBadges={showTextBadges}
                showCompare={showCompare}
                // maxTextBadges={maximumNumberOfTextBadges}
                // maxImageBadges={maximumNumberOfImageBadges}
            />
            {/* <ProductListActions showAddToList={showAddToList} showPrice={showPrice} /> */}
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
